﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { TranslationService } from "../../services/TranslationService";
import { Severity } from "../../models/serviceCase";

@Component({
    module: FIQAssist,
    selector: "severitychecklistcombo",
    template: `
            <checklistcombo value-sumbit="$ctrl.passValueSubmit(selected)" read-only="$ctrl.readOnly" onselectionchanged="$ctrl.severitiesselected(selected)"
                items="$ctrl.items" showAllOption="false"
                all-selected-text="$ctrl.ALL_SEVERITIES_SELECTED | translate "
                multiple-selected-text="$ctrl.MULTIPLE_SEVERITIES_SELECTED | translate"
                none-selected-text="''" checked="$ctrl.severities" show-clear="{{$ctrl.showClear}}"
                ></checklistcombo>`
})
class SeverityChecklistCombo implements IComponent {
    @Input() public readOnly: boolean;
    private _severities: { key: Severity, text: string }[];
    private initialized: boolean = false;
    private MULTIPLE_SEVERITIES_SELECTED = "MULTIPLE_SEVERITIES_SELECTED";
    private ALL_SEVERITIES_SELECTED = "ALL_SEVERITIES_SELECTED";

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject() private translationService: TranslationService
    ) { }

    $onInit() {
        this.initialized = true;
        this.items = <{ key: Severity, text: string }[]>[
            {key: 'level1' ,text: 'Level 1'},
            {key: 'level2' ,text: 'Level 2'},
            {key: 'level3' ,text: 'Level 3'},
            {key: 'level4' ,text: 'Level 4'}];

        this.translateItems();
    }

    private async translateItems() {
        await this.translationService.onLoaded;
        this.items = this.items.map(i => { i.text = this.translationService.Translate(i.text); return i; }).sort((a, b) => a.text > b.text ? 1 : -1);
    }

    @Input()
    public get severities(): { key: Severity, text: string }[] {
        return this._severities;
    }
    public set severities(severities: { key: Severity, text: string }[]) {
        this._severities = severities;
    }
    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }
    private items: { key: Severity, text: string }[];

    public severitiesselected(selected: any[]) {
        this.severities = selected;
        this.onSeverityChanged({ severities: this.severities });
    }

    @Output() public onSeverityChanged: (args: { severities: any[] }) => void;
    @Output() public valueSubmit: OutputArgs<{ severities: { key: string, text: string }[] }>;
    public passValueSubmit(selected: any[]) {
        this.severities = selected;
        if (this.valueSubmit) this.valueSubmit({ severities: this.severities });
    }
}
